import { rem } from '../../utils/functions.js';
import { typography } from '../../typography/typography.js';

var FONT_SIZE = {
  SMALL: typography.fontSize,
  MEDIUM: rem(18),
  LARGE: rem(20)
};
var HEADER_LEVEL = {
  H1: '1',
  H2: '2',
  H3: '3',
  H4: '4',
  H5: '5',
  H6: '6',
  NONE: 'None'
};

export { FONT_SIZE, HEADER_LEVEL };
